const RANGE_FILTER = ['growth', 'experience'];

export const updateBackgroundColor = ((filter, maxValue, sliderTrackId) => {
  const percent1 = (filter?.min / maxValue) * 100;
  const percent2 = (filter?.max / maxValue) * 100;
  const sliderTrack = document.getElementById(sliderTrackId);

  if (!sliderTrack) return;

  sliderTrack.style.background = `
  linear-gradient(to right, #dadae5 ${percent1}%, 
    rgba(26, 132, 82, 1) ${percent1}%, 
    rgba(26, 132, 82, 1) ${percent2}%, #dadae5 ${percent2}%)`;
});

export const getExperienceThumbPosition = (mobile, value, maxValue) => {
  const basePosition = (value / maxValue) * (mobile ? 25 : 100);

  if (value <= 5) {
    return mobile
      ? basePosition + (8 - value) / 10
      : basePosition + (5 - value);
  } else {
    return mobile
      ? basePosition
      : basePosition - (value - 3.5);
  }
};

export const getSalaryThumbPosition = ((mobile, value, maxValue) => {
  if (mobile) {
    return ((value / maxValue) / 100) * 27 + 1;
  } else if (value === 900) {
    return 91.5;
  } else if (value <= 300) {
    return (value / maxValue) + ((550 - value) / 100);
  } else if (value <= 400) {
    return (value / maxValue) + ((650 - value) / 100);
  } else if (value <= 600) {
    return (value / maxValue) + ((800 - value) / 100);
  } else {
    return (value / maxValue) + ((value - 450) / 100);
  }
});

export const getFilteredOptions = (
  (options = [], exclusions = []) => options
    .filter(
      (option) => !exclusions.some(
        (exclusion) => exclusion.toLowerCase() === option.toLowerCase(),
      ),
    )
    .sort((a, b) => {
      const startsWithNumber = (str) => /^\d/.test(str);
      if (startsWithNumber(a) && !startsWithNumber(b)) {
        return 1;
      }
      if (!startsWithNumber(a) && startsWithNumber(b)) {
        return -1;
      }
      return a.localeCompare(b);
    })
);

export const targetCompanyOptions = [
  { value: 'Flipkart,Swiggy', label: 'High Growth Startups' },
  { value: 'Walmart, Samsung', label: 'Established Businesses' },
  { value: 'Fractal, Thoughtworks', label: 'Amazing Startups' },
  { value: 'Indium Software, Niro', label: 'SMB' },
  { value: 'Infosys, Deloitte', label: 'Services' },
  { value: 'Arcesium', label: 'Established Business' },
  { value: 'Morgan Stanley', label: 'Investment Bank' },
  { value: 'Student/Fresher', label: 'Student' },
];

export const sortedDropdownOptions = (options, exclusions) => {
  const startsWithNumber = (str) => /^\d/.test(str);

  return options
    .filter((option) => !exclusions.some(
      (exclusion) => exclusion.toLowerCase() === option.toLowerCase(),
    ))
    .map((option) => ({ value: option, label: option }))
    .sort((a, b) => {
      if (startsWithNumber(a.label) && !startsWithNumber(b.label)) {
        return 1;
      }
      if (!startsWithNumber(a.label) && startsWithNumber(b.label)) {
        return -1;
      }
      return a.label.localeCompare(b.label);
    });
};

export const createAdvancedFiltersQueryDesktop = (
  advancedFilters, sharedFilter,
) => {
  const currentFilters = {
    pre_scaler_role_matches_any: advancedFilters.currentStatus,
    pre_academy_company_matches_any: advancedFilters.currentCompany,
    role_matches_any: advancedFilters.targetRole,
    post_academy_segment_matches_any: advancedFilters.targetCompany,
    college_matches_any: advancedFilters.currentCollege,
  };


  const normalizedFilters = Object.fromEntries(
    Object.entries(currentFilters).map(([key, value]) => [
      key,
      // eslint-disable-next-line no-nested-ternary
      Array.isArray(value)
        ? value.map((item) => item.label)
        : value?.label
          ? [value.label]
          : [],
    ]),
  );

  const updatedFilters = {
    ...sharedFilter,
    ...normalizedFilters,
  };

  const filteredFilters = Object.fromEntries(
    Object.entries(updatedFilters).filter(
      // eslint-disable-next-line no-unused-vars
      ([_, value]) => value.length > 0,
    ),
  );

  const query = {};

  Object.keys(filteredFilters).forEach((key) => {
    let values = [];

    if (RANGE_FILTER.includes(key)) {
      filteredFilters[key].forEach((filter) => {
        values.push({
          max: filter?.max,
          min: filter?.min,
        });
      });
      query[key] = values;
    } else {
      values = filteredFilters[key];
      query[key] = values;
    }
  });

  return query;
};

export const createAdvancedFiltersQuery = (selectedFilters) => {
  const filteredFilters = Object.fromEntries(
    Object.entries(selectedFilters).filter(
      // eslint-disable-next-line no-unused-vars
      ([_, value]) => value.length > 0,
    ),
  );

  const query = {};

  Object.keys(filteredFilters).forEach((key) => {
    let values = [];

    if (RANGE_FILTER.includes(key)) {
      filteredFilters[key].forEach((filter) => {
        values.push({
          max: filter?.max,
          min: filter?.min,
        });
      });
      query[key] = values;
    } else {
      values = filteredFilters[key];
      query[`${key}_matches_any`] = values;
    }
  });

  return query;
};
